import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slider,
} from "@material-ui/core";
import parsePhoneNumber from "libphonenumber-js";
import React, { useEffect, useState } from "react";
import ReactFlagsSelect from "react-flags-select";
import { useDispatch, useSelector } from "react-redux";
import {
    dataURLtoFile,
    IsNullOrEmpty,
    slugify,
    validEmail,
    validPhone,
} from "../../helpers/utility";
import { uploadAvatarRequest } from "../../store/file/file.actions";
import { getUploadedAvatarImage } from "../../store/file/file.selector";
import SocialAPI from "../../store/social/social.api";
import {
    fetchUserProfileRequest,
    updateUserProfileRequest,
} from "../../store/user/user.actions";
import {
    getProfileImage,
    getUserProfile,
} from "../../store/user/user.selector";
import Cropper from "react-easy-crop";
import ReactCrop, {
    centerCrop,
    makeAspectCrop,
    Crop,
    PixelCrop,
} from "react-image-crop";
import welcomeIcon from "../../assets/images/welcome.svg";
import Swal from "sweetalert2";

const Profile = () => {
    const [name, setName] = useState("");
    const [userName, setUserName] = useState("");
    const [bio, setBio] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [link, setLink] = useState("");
    const [showMe, setShowMe] = useState(false);
    const [selected, setSelected] = useState("MY");
    const [countryCode, setCountry] = useState("+60");
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [open, setOpen] = useState(false);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState({});

    const [src, setSrc] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [aspect, setAspect] = useState(1);
    const [image, setImage] = useState(null);
    const [output, setOutput] = useState(null);

    const dispatch = useDispatch();
    const [bannerImageSrc, setBannerImageSrc] = useState("");

    const onCropChange = (crop) => {
        setCrop(crop);
    };

    const onCropComplete = (croppedArea, px) => {
        setCroppedAreaPixels(px);
    };

    const onZoomChange = (zoom) => {
        setZoom(zoom);
    };

    const handleSelect = (code) => {
        setSelected(code);
        if (code === "SG") setCountry("+65");
        if (code === "MY") setCountry("+60");
        if (code === "US") setCountry("+1");
    };

    const { userProfile, profileImage, updateImage } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
            profileImage: getUploadedAvatarImage(state),
            updateImage: getProfileImage(state),
        };
    });

    useEffect(() => {
        if (!userProfile._id) {
            dispatch(fetchUserProfileRequest());
        }
    }, []);

    useEffect(() => {
        if (userProfile._id && (!userProfile.phone || !userProfile.email)) {
            Swal.fire({
                allowOutsideClick: false,
                title: "Welcome to Ulalive",
                text: "We’re glad you’re here, please complete your profile to get started.",
                icon: "warning",
                iconHtml: `<img src="${welcomeIcon}" class="p-4" />`,
                confirmButtonText: "Complete profile",
                showCancelButton: false,
                customClass: {
                    cancelButton: "order-1 right-gap",
                    confirmButton: "order-2",
                    denyButton: "order-3",
                    icon: "custom-swal-icon",
                },
            }).then((x)=>{
                if(x.isConfirmed){
                    setShowMe(false);
                }
            })
        }
    }, [userProfile]);

    const selectImage = (file) => {
        setOpen(true);
        setSrc(URL.createObjectURL(file));
    };

    const cropImageNow = () => {
        var img = document.createElement("img");
        img.src = src;
        img.onload = () => {
            const canvas = document.getElementById("canvas");
            // const scaleX = image.naturalWidth / image.width;
            // const scaleY = image.naturalHeight / image.height;
            canvas.width = croppedAreaPixels.width;
            canvas.height = croppedAreaPixels.height;
            const ctx = canvas.getContext("2d");

            const pixelRatio = window.devicePixelRatio;
            canvas.width = croppedAreaPixels.width * pixelRatio;
            canvas.height = croppedAreaPixels.height * pixelRatio;
            ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            ctx.imageSmoothingQuality = "high";

            ctx.drawImage(
                img,
                croppedAreaPixels.x,
                croppedAreaPixels.y,
                croppedAreaPixels.width,
                croppedAreaPixels.height,
                0,
                0,
                croppedAreaPixels.width,
                croppedAreaPixels.height
            );

            // Converting to base64
            const base64Image = canvas.toDataURL("image/jpeg");
            var files = dataURLtoFile(base64Image, userProfile._id + ".png");
            dispatch(uploadAvatarRequest(files));
            setBannerImageSrc(base64Image);
            setOpen(false);
            setOutput(base64Image);
        };
    };

    useEffect(() => {
        setName(userProfile.fullName);
        setUserName(userProfile.userName);
        setBio(userProfile.descriptions);
        const phoneNumber = parsePhoneNumber(userProfile.phone, "MY");
        if (phoneNumber) {
            setPhone(phoneNumber.nationalNumber);
            setCountry("+" + phoneNumber.countryCallingCode);
            if (phoneNumber.countryCallingCode === "1") setSelected("US");
            if (phoneNumber.countryCallingCode === "65") setSelected("SG");
            if (phoneNumber.countryCallingCode === "60") setSelected("MY");
        }

        setEmail(userProfile.email);
        setLink(userProfile.website);

        if (
            IsNullOrEmpty(userProfile.email) ||
            IsNullOrEmpty(userProfile.phone)
        ) {
            setShowMe(true);
        }
    }, [userProfile]);

    const validate = () => {
        return (
            !IsNullOrEmpty(name) &&
            !IsNullOrEmpty(userName) &&
            !IsNullOrEmpty(phone) &&
            validPhone(phone) &&
            validEmail(email) &&
            !IsNullOrEmpty(email)
        );
    };

    const handleSave = () => {
        if (validate()) {
            let data = {
                fullName: name,
                userName: userName,
                phone: countryCode + phone,
                email: email,
                website: link,
                descriptions: bio,
            };
            if (!IsNullOrEmpty(profileImage._id)) {
                data.avatar = profileImage._id;
            }
            dispatch(updateUserProfileRequest(data));
            if (!userProfile.phone || !userProfile.email) {
                SocialAPI.CreateWelcomeMessage({});
            }
        } else {
            setFormSubmitted(true);
        }
    };

    if (!userProfile._id || showMe) {
        return <p></p>;
    }

    return (
        <div className="flex flex-col md:flex-row gap-x-8">
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                onClose={() => setOpen(false)}
            >
                <DialogTitle title="Change Profile Picture" />
                <DialogContent style={{ minHeight: 500 }}>
                    {/* <p>Select and crop the image to fit</p>
							<Slider step={0.1} max={2} min={1} value={zoom} onChange={(e, val) => setZoom(val)} aria-labelledby="continuous-slider" /> */}
                    {Boolean(src) && (
                        // <ReactCrop
                        // 	circularCrop={true}
                        // 	src={src}
                        // 	onImageLoaded={setImage}
                        // 	crop={crop}
                        // 	aspect={1}
                        // 	scale={zoom}
                        // 	onChange={setCrop}
                        // >
                        // </ReactCrop>
                        <div className="app-div">
                            <div className="crop-container">
                                <Cropper
                                    image={src}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={aspect}
                                    cropSize={{ width: 300, height: 300 }}
                                    cropShape="round"
                                    showGrid={false}
                                    onCropChange={onCropChange}
                                    onCropComplete={onCropComplete}
                                    onZoomChange={onZoomChange}
                                />
                            </div>
                            <div className="controls">
                                <Slider
                                    value={zoom}
                                    min={1}
                                    max={3}
                                    step={0.1}
                                    aria-labelledby="Zoom"
                                    onChange={(e, zoom) => onZoomChange(zoom)}
                                    classes={{ container: "slider" }}
                                />
                            </div>
                        </div>
                    )}
                    <canvas id="canvas" style={{ display: "none" }}></canvas>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="default"
                        onClick={() => setOpen(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => cropImageNow()}
                    >
                        Upload
                    </Button>
                </DialogActions>
            </Dialog>
            <div className="flex justify-center md:justify-start">
                <div className="upload-btn-img">
                    <div className="w-[175px] h-[175px] rounded-full relative">
                        <img
                            src={bannerImageSrc ? bannerImageSrc : updateImage}
                            className="w-[175px] h-[175px] rounded-full"
                            alt=""
                        />
                        <span className="text-gray-900 hover:text-purple-color p-3 shadow-[0px_4px_4px] shadow-black-10 cursor-pointer bg-white rounded-full absolute bottom-0 right-0">
                            <svg
                                width="21"
                                height="19"
                                className="stroke-current"
                                viewBox="0 0 21 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.125 6.37533C1.125 5.22473 2.05774 4.29199 3.20833 4.29199H4.1767C4.87327 4.29199 5.52375 3.94386 5.91014 3.36428L6.75653 2.0947C7.14292 1.51512 7.7934 1.16699 8.48997 1.16699H12.51C13.2066 1.16699 13.8571 1.51512 14.2435 2.0947L15.0899 3.36428C15.4762 3.94387 16.1267 4.29199 16.8233 4.29199H17.7917C18.9423 4.29199 19.875 5.22473 19.875 6.37533V15.7503C19.875 16.9009 18.9423 17.8337 17.7917 17.8337H3.20833C2.05774 17.8337 1.125 16.9009 1.125 15.7503V6.37533Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M13.625 10.542C13.625 12.2679 12.2259 13.667 10.5 13.667C8.77411 13.667 7.375 12.2679 7.375 10.542C7.375 8.8161 8.77411 7.41699 10.5 7.41699C12.2259 7.41699 13.625 8.8161 13.625 10.542Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                    </div>
                    <input
                        type="file"
                        name="banner_image"
                        accept="image/*"
                        onChange={(e) => {
                            selectImage(e.target.files[0]);
                        }}
                    />
                </div>
            </div>
            <div className="pt-7 flex-1 overflow-y-auto overflow-x-hidden">
                <div className="flex flex-col">
                    <div
                        className={`flex flex-col py-[9px] px-[13px] bg-white border border-[${formSubmitted && IsNullOrEmpty(name)
                            ? "#FF0000"
                            : "#D1D5DB"
                            }] rounded-md w-full text-sm mb-[7px]`}
                    >
                        <label
                            htmlFor="name"
                            className="text-black-100 capitalize mb-px"
                        >
                            Name<span className="text-red-600"> *</span>
                        </label>
                        <input
                            type="text"
                            className="text-black-50 outline-none"
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </div>
                    {formSubmitted && IsNullOrEmpty(name) && (
                        <p className="my-1 text-sm text-red-600 dark:text-red-500">
                            <span className="font-medium">Name</span> should be
                            valid.
                        </p>
                    )}
                    <div
                        className={`flex flex-col py-[9px] px-[13px] bg-white border border-[${formSubmitted && IsNullOrEmpty(userName)
                            ? "#FF0000"
                            : "#D1D5DB"
                            }] rounded-md w-full text-sm mb-[7px]`}
                    >
                        <label
                            htmlFor="username"
                            className="text-black-100 capitalize mb-px"
                        >
                            Username<span className="text-red-600"> *</span>
                        </label>
                        <input
                            type="text"
                            className="text-black-50 outline-none"
                            id="username"
                            value={userName}
                            onChange={(e) =>
                                setUserName(slugify(e.target.value))
                            }
                        />
                    </div>
                    {formSubmitted && IsNullOrEmpty(userName) && (
                        <p className="my-1 text-sm text-red-600 dark:text-red-500">
                            <span className="font-medium">Username</span> should
                            be valid.
                        </p>
                    )}
                    <div
                        style={{
                            background: !IsNullOrEmpty(userProfile.phone)
                                ? "#F3F5F6"
                                : "#FFFFFF",
                        }}
                        className="flex justify-start bg-white border border-[#D1D5DB] rounded-md w-full text-sm mb-[7px] "
                    >
                        <ReactFlagsSelect
                            className="react-select text-sm"
                            selected={selected}
                            disabled={!IsNullOrEmpty(userProfile.phone)}
                            onSelect={(code) => handleSelect(code)}
                            countries={["MY", "SG", "US"]}
                            customLabels={{
                                MY: "Malaysia +60",
                                SG: "Singapore +65",
                                US: "United States +1",
                            }}
                        />
                        <div
                            className="flex flex-col py-[9px] px-[13px] bg-white"
                            style={{
                                background: !IsNullOrEmpty(userProfile.phone)
                                    ? "#F3F5F6"
                                    : "#FFFFFF",
                            }}
                        >
                            <label
                                htmlFor="mobile"
                                className="text-black-100 capitalize mb-px"
                            >
                                Mobile<span className="text-red-600"> *</span>
                            </label>

                            <input
                                type="number"
                                className="text-black-50 outline-none"
                                id="mobile"
                                disabled={!IsNullOrEmpty(userProfile.phone)}
                                value={phone}
                                onChange={(e) => {
                                    setPhone(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                    {formSubmitted && IsNullOrEmpty(phone) && (
                        <p className="my-1 text-sm text-red-600 dark:text-red-500">
                            <span className="font-medium">Phone</span> should be
                            valid.
                        </p>
                    )}

                    <div
                        className={`flex flex-col py-[9px] px-[13px] bg-white border 
                    border-[${formSubmitted && IsNullOrEmpty(email)
                                ? "#FF0000"
                                : "#D1D5DB"
                            }] rounded-md w-full text-sm mb-[7px]`}
                        style={{
                            background: !IsNullOrEmpty(userProfile.email)
                                ? "#F3F5F6"
                                : "#FFFFFF",
                        }}
                    >
                        <label
                            htmlFor="email"
                            className="text-black-100 capitalize mb-px"
                        >
                            email<span className="text-red-600"> *</span>
                        </label>
                        <input
                            type="email"
                            className="text-black-50 outline-none"
                            id="email"
                            disabled={!IsNullOrEmpty(userProfile.email)}
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                            }}
                        />
                    </div>
                    {formSubmitted && IsNullOrEmpty(email) && (
                        <p className="my-1 text-sm text-red-600 dark:text-red-500">
                            <span className="font-medium">Email</span> should be
                            valid.
                        </p>
                    )}
                    <div className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm mb-[7px]">
                        <label
                            htmlFor="link"
                            className="text-black-100 capitalize mb-px"
                        >
                            link
                        </label>
                        <input
                            type="url"
                            className="text-black-50 outline-none"
                            id="link"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                        />
                    </div>
                    <div className="flex flex-col py-[9px] px-[13px] bg-white border border-[#D1D5DB] rounded-md w-full text-sm mb-3.5">
                        <label
                            htmlFor="link"
                            className="text-black-100 capitalize mb-px"
                        >
                            Say something about you
                        </label>
                        <textarea
                            className="w-full text-black-60 placeholder:text-black-50 outline-none min-h-16"
                            placeholder="Say something about you"
                            name=""
                            id=""
                            cols="30"
                            rows="3"
                            value={bio}
                            onChange={(e) => setBio(e.target.value)}
                        ></textarea>
                    </div>
                    <div className="flex items-center gap-x-3">
                        <button
                            onClick={() => handleSave()}
                            className="py-2.5 px-5 text-sm rounded-lg border border-transparent bg-orange-color text-white font-bold capitalize"
                        >
                            save
                        </button>
                        <button className="py-2.5 px-5 text-sm rounded-lg border border-black-10 bg-white text-black-50 font-medium capitalize">
                            cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;
